import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Courses from "@/pages/Courses";
import Workshops from "@/pages/Workshops";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ModulePlayer from "@/pages/ModulePlayer";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import SeatManager from "@/pages/SeatManager";
import InviteAccept from "@/pages/InviteAccept";
import Cart from "@/pages/Cart";

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-sm text-muted-foreground">Loading…</div>;
    if (!user) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }
    return children;
}

function Shell() {
    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/courses" element={<Courses />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/workshops" element={<Workshops />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/checkout/success" element={<CheckoutSuccess />} />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/learn/:moduleId"
                        element={
                            <ProtectedRoute>
                                <ModulePlayer />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/license/seats"
                        element={
                            <ProtectedRoute>
                                <SeatManager />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/invite/:token" element={<InviteAccept />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </main>
            <Footer />
            <Toaster richColors position="top-right" />
        </div>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <CartProvider>
                    <Shell />
                </CartProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
